import {

  FIND_MATCHES_FAILED,
  FIND_MATCHES_SUCCESS,
  FIND_MATCHES_START,
  FIND_LISTING_MATCHES_START,
  FIND_LISTING_MATCHES_SUCCESS,
  FIND_LISTING_MATCHES_FAILED

} from "../store/types";

import { store } from "../store/store";

import { isEmpty } from "../other/Utils";

import { mapListingEnquiryPropertyTypes } from "../functions/commonFunctions";



export const clearMatchingErrors = () => (dispatch) => (firebase) => {
  dispatch({
    type: CLEAR_ENQUIRY_ERROR,
    payload: null,
  });
};





export const MatchListingToEnquiry =
  (EnquiryData) => (dispatch) => (firebase) => {
    //Please send the full Enquiry object with the update data and the data that was not updated
    const { ListingRef, auth } = firebase;
    dispatch({
      type: FIND_MATCHES_START,
      payload: null,
    });

    try {
      if (EnquiryData) {
        let minVariant = Math.round(parseInt(EnquiryData.sizeMin * 0.5))
        let maxVariant = Math.round(parseInt(EnquiryData.sizeMax * 1.5))
        ListingRef
          .orderByChild("userdetials/id")
          .equalTo(auth.currentUser.uid)
          .once("value", (snapshot) => {
            let Listings = snapshot.val();
            if (Listings) {
              let ListingsData = Object.values(Listings);

              let matchedData = []



              if ((EnquiryData.sizeMin !== "" && EnquiryData.sizeMin !== null) && (EnquiryData.sizeMax !== "" && EnquiryData.sizeMax !== null)) {


                matchedData = ListingsData.filter((Listing) => {
                  let TotalSize = Listing.gla ? Listing.gla : 0


                  const hasImages = Object.values(Listing.images ? Listing.images : []).length > 0
                  const hasType = (typeof EnquiryData.industrialCommercial === 'string' && typeof Listing.industrialCommercial === 'string')
                  const isTypeMatch = Listing.industrialCommercial === EnquiryData.industrialCommercial;
                  const hasPropertyType = (typeof EnquiryData.typeOfProperty === 'string' && typeof Listing.typeOfProperty === 'string')
                  const isPropertyMatch = mapListingEnquiryPropertyTypes(Listing.typeOfProperty, EnquiryData.typeOfProperty);

                  return (
                    ((minVariant <= TotalSize) && (maxVariant >= TotalSize))
                    && ((!Listing.archive) && (!["Archived", "Rented", "Sold", "Pending"].includes(Listing.status)))
                    && (hasImages) && isTypeMatch && isPropertyMatch
                  )

                })


              }



              dispatch({
                type: FIND_MATCHES_SUCCESS,
                payload: matchedData,
              });
            } else {
              dispatch({
                type: FIND_MATCHES_SUCCESS,
                payload: null,
              });
            }



          })

      } else {
        dispatch({
          type: FIND_MATCHES_FAILED,
          payload: "Please double check inputted data",
        });
      }
    } catch (error) {
      dispatch({
        type: FIND_MATCHES_FAILED,
        payload: error,
      });
    }
  };


//function used to check if the current login user has archived the funtion
function checkEnquiryArchived(item, auth) {
  let archivedBrokers = item ? Object.entries(item) : [];
  if (archivedBrokers?.length > 0) {
    let isArchived = archivedBrokers.find(
      (x) => x[1].brokerId === auth.currentUser.uid
    );
    let archiveData =
      isArchived !== undefined
        ? { ...isArchived[1], archiveId: isArchived[0], isArchived: true }
        : { isArchived: false };
    return archiveData;
  } else {
    return { isArchived: false };
  }
}


export const MatchEnquiryToListings = (ListingData) => (dispatch) => (firebase) => {
  const { auth } = firebase;

  dispatch({ type: FIND_LISTING_MATCHES_START, payload: null });

  try {
    const enquiries = store.getState().enquirydata.enquiries;

    if (!enquiries) {
      return dispatch({
        type: FIND_LISTING_MATCHES_FAILED,
        payload: "Please double check inputted data",
      });
    }

    const totalSize = ListingData.gla || 0;
    const isIndustrialCommercial = ListingData.industrialCommercial;


    const activeMatchedData = [];
    const archivedMatchedData = [];

    enquiries.forEach((enquiry) => {
      const minSize = Math.round(enquiry.sizeMin * 0.5);
      const maxSize = Math.round(enquiry.sizeMax * 1.5);

      const isSizeMatch = totalSize >= minSize && totalSize <= maxSize;
      const isTypeMatch = enquiry.industrialCommercial === isIndustrialCommercial;
      const isPropertyMatch = mapListingEnquiryPropertyTypes(ListingData.typeOfProperty, enquiry.typeOfProperty);

      if (isSizeMatch && isTypeMatch && isPropertyMatch) {


        const enrichedEnquiry = { ...enquiry, id: enquiry.id };
        let archiveData = checkEnquiryArchived(enrichedEnquiry.archivedbroker, auth);

        if (
          enquiry.status === "Active" &&
          !enquiry.archive &&
          !archiveData.isArchived
        ) {
          activeMatchedData.push(enrichedEnquiry);
        } else {
          archivedMatchedData.push(enrichedEnquiry);
        }

      }

    });

    const sortByCreatedAtDesc = (a, b) => (b.CreatedAt || 0) - (a.CreatedAt || 0);

    const sortedMatchedData = {
      activeMatchedData: activeMatchedData.sort(sortByCreatedAtDesc),
      archivedMatchedData: archivedMatchedData.sort(sortByCreatedAtDesc),
    };

    dispatch({
      type: FIND_LISTING_MATCHES_SUCCESS,
      payload: sortedMatchedData,
    });

  } catch (error) {
    console.error("MatchEnquiryToListings error:", error);
    dispatch({
      type: FIND_LISTING_MATCHES_FAILED,
      payload: error,
    });
  }
};

